import { Input, Typography } from 'antd'
import { useIndicationData } from 'features/indicationTriage/IndicationContext'
import { useUpdateIndicationContext } from 'features/indicationTriage/updateIndicationContext'
import { IndicationDetailCardProps } from 'features/indicationTriage/useIndicationDetailCards'
import isNil from 'lodash/isNil'
import React, { FC, useCallback, useState } from 'react'

const { TextArea } = Input
const { Text } = Typography

export const Width = '24rem'
export const Title = () => 'Notes'
export const CardView: FC<IndicationDetailCardProps> = () => {
  const { indication: indicationItem } = useIndicationData()
  const [editingNote, setEditingNote] = useState<string | null>(null)
  const { updateOrAddIndication } = useUpdateIndicationContext()

  const handleNoteUpdate = useCallback(() => {
    if (!updateOrAddIndication || !indicationItem || isNil(editingNote)) {
      return
    }
    updateOrAddIndication({
      ...indicationItem,
      note: editingNote,
    })
    setEditingNote(null)
  }, [editingNote, indicationItem, updateOrAddIndication])

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <Text strong style={{ width: '82%' }}>
        Notes
      </Text>
      <TextArea
        rows={3}
        value={isNil(editingNote) ? indicationItem?.note : editingNote}
        onChange={(e) => {
          setEditingNote(e.target.value)
        }}
        onClick={(e) => e.stopPropagation()}
        onBlur={handleNoteUpdate}
      />
    </div>
  )
}
